export const needsUpgrade = (newAccountImplementationType, smartAccount) => newAccountImplementationType === 'modular' && smartAccount.type === 'simple';
